/**
 * Zod schema for a patient note (V2 live patient management). Single source of
 * truth for the note body's shape/rules; the API's class-validator DTO mirrors
 * it and the const is imported by both sides so they can't drift.
 *
 * Kept dependency-light: only `zod`.
 */
import { z } from "zod";

/** Max length of a single note body. */
export const NOTE_BODY_MAX_LENGTH = 2000;

/** A note body: required, non-empty after trim, capped. */
export const noteBodySchema = z
  .string()
  .trim()
  .min(1, "A note can't be empty")
  .max(NOTE_BODY_MAX_LENGTH, `A note must be ${NOTE_BODY_MAX_LENGTH} characters or fewer`);

export const noteInputSchema = z.object({ body: noteBodySchema });

export type NoteInput = z.infer<typeof noteInputSchema>;
